import React, { useEffect, useRef, useState } from "react";
import apiRequest from "../service/api/api.request";
import InputBlockv1 from "../UI/components/InputBlockv1";
import { observer } from "mobx-react-lite";
import userState from "../service/state/user.state";
import controllerState from "../service/state/controller.state";
import Input_v2_bbred from "../UI/components/Input_v2_bbred";
import iconEdit from "../images/icons/pencil_red32.png";
import iconSave from "../images/icons/save_dark_grey48.png";
import UserSetting from "../components/user/UserSetting";
import media from "../service/state/media";

export const UserProfile = observer(() => {
  // const [profile, setProfile] = useState(null);
  const [name, setName] = useState("");
  const [lastName, setlastName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [organization, setOrganization] = useState(null);
  const [amountControllers, setamountControllers] = useState(0);
  const [edit, setEdit] = useState(false);

  useEffect(() => {
    if (controllerState.controllers) {
      setamountControllers(controllerState.controllers.length);
    }
  }, [controllerState.controllers]);

  const getProfile = async () => {
    await apiRequest.getProfile();
    setName(userState.profile.name);
    setlastName(userState.profile.last_name);
    setFatherName(userState.profile.father_name);
    setEmail(userState.profile.email);
    setPhone(userState.profile.phone);
    setOrganization(userState.profile.organization);
  };

  useEffect(() => {
    getProfile();
  }, []);

  const saveProfile = async () => {
    if (name === "") return alert("Имя не задано");
    if (lastName === "") return alert("Фамилия не задана");
    if (email === "") return alert("Email не задан");
    if (phone === "") return alert("Телефон не задан");
    const res = await apiRequest.patchprofile({
      first_name: name,
      last_name: lastName,
      organization: organization,
      father_name: fatherName,
      email: email,
      phone: phone,
    });
    if (res.success) {
      setEdit(false);
    } else {
      alert(`Не удалось изменить профиль: ${res.message}`);
    }
  };

  if (userState.profile.uploaded) {
    return (
      <div className="page">
        <div className="flx_bt">
          <div
            className="flx_bt"
            style={{ flexDirection: !media.mobile ? "row" : "column" }}
          >
            <ul className="list_profile">
              <li className="list_profile_name">
                {!edit ? (
                  name
                ) : (
                  <span>
                    Имя:{" "}
                    <Input_v2_bbred
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Имя"
                    />
                  </span>
                )}{" "}
                {!edit ? (
                  fatherName
                ) : (
                  <span>
                    Отчество:{" "}
                    <Input_v2_bbred
                      value={fatherName}
                      onChange={(e) => setFatherName(e.target.value)}
                      placeholder="Отчество"
                    />
                  </span>
                )}{" "}
                {!edit ? (
                  lastName
                ) : (
                  <span>
                    {" "}
                    Фамилия:{" "}
                    <Input_v2_bbred
                      value={lastName}
                      onChange={(e) => setlastName(e.target.value)}
                      placeholder="Фамилия"
                    />
                  </span>
                )}{" "}
              </li>
              <li>
                <span className="list_profile_span">Организация: </span>
                {!edit ? (
                  <> {organization !== null ? organization : "Не заполнена"}</>
                ) : (
                  <span>
                    <Input_v2_bbred
                      value={organization}
                      onChange={(e) => setOrganization(e.target.value)}
                      placeholder="Организация"
                    />
                  </span>
                )}
              </li>
              <li>
                <span className="list_profile_span">E-mail: </span>
                {!edit ? (
                  email
                ) : (
                  <span>
                    <Input_v2_bbred
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="E-mail"
                    />
                  </span>
                )}
              </li>
              <li>
                <span className="list_profile_span">Телефон: </span>
                {!edit ? (
                  phone
                ) : (
                  <span>
                    <Input_v2_bbred
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="Телефон"
                    />
                  </span>
                )}
              </li>
              <li>
                <span className="list_profile_span">Контроллеров: </span>
                {amountControllers}
              </li>
            </ul>
            <UserSetting edit={edit} />
          </div>

          <div className="btn_edit_conteiner">
            {edit ? (
              <img
                onClick={saveProfile}
                className="edit_btn"
                src={iconSave}
                alt="Сохранить"
              />
            ) : (
              <></>
            )}
            <img
              onClick={() => setEdit(!edit)}
              className="edit_btn"
              src={iconEdit}
              alt="Редактировать"
            />
          </div>
        </div>
      </div>
    );
  }
});
